import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { SynchronizePaymentTradesService } from "@/features/accounts/payment/scraping/services/synchronize-trades-service";


export const useSynchronizePaymentTrades = () => {
  const { setError } = useContext(ErrorDialogContext);
  const loadingCtx = useContext(LoadingModalContext);
  const synchronizePaymentTradesService = new SynchronizePaymentTradesService();
  
  // Look明細同期
  const synchronizePaymentTrades = async (
    accountGroupId: string,
    mlinkAccountId: string,
    mlinkId: string,
    startDate: string,
    endDate: string
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await synchronizePaymentTradesService.synchronizePaymentTrades({
        account_group_id: accountGroupId,
        payment_account_id: mlinkAccountId,
        payment_id: mlinkId,
        start_date: startDate,
        end_date: endDate,
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      // TODO: ここでエラーraiseしてダイアログ表示するかも
      console.log("synchronizePaymentTrades:", error);
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    synchronizePaymentTrades: errorHandledAsync(synchronizePaymentTrades, setError),
  };
};
